export const NOTICE_SUCCESS_TYPE = 'SUCCESS';
export const NOTICE_ERROR_TYPE = 'ERROR';

export const SHOW_NOTICE = 'SHOW_NOTICE';
export const HIDE_NOTICE = 'HIDE_NOTICE';
export const LOAD_NEXT_NOTICE = 'LOAD_NEXT_NOTICE';

export const SUBSCRIPTION_CODE_NOTICE_DURATION_MS = 7000;

export function showFlashNotice(notice) {
  return {
    type: SHOW_NOTICE,
    notice,
  };
}

export function hideFlashNotice() {
  return {
    type: HIDE_NOTICE,
  };
}

export function loadNextNotice() {
  return {
    type: LOAD_NEXT_NOTICE,
  };
}
